// @internal
import styled, { css } from 'styled-components';
import { StyledSideNavProps } from '../../styles';
import { sidenavTokens } from '../../../../tokens/components/SideNav/tokens';

type StyledSideNavSectionLabelProps = Pick<StyledSideNavProps, 'isClosed'>;

export const StyledSideNavSectionLabel = styled.h4<StyledSideNavSectionLabelProps>`
  border-top: ${sidenavTokens.SectionLabelBorderTopBaseDefault};
  color: ${sidenavTokens.SectionLabelFontColorBaseDefault};
  font-size: ${sidenavTokens.SectionLabelFontSizeBaseDefault};
  padding-top: ${sidenavTokens.SectionLabelPaddingVerticalBaseOpen};
  margin: ${sidenavTokens.SectionLabelMarginBaseOpen};
  text-transform: uppercase;

  ${({ isClosed }) =>
    isClosed &&
    css`
      margin: ${sidenavTokens.SectionLabelMarginBaseClosed};
      padding-top: ${sidenavTokens.SectionLabelPaddingVerticalBaseClosed};
      width: 100%;
    `};
`;
